export default {
  data () {
    return {
      allSearchLabelList: [],
      allSearchLabelListOrigin: []
    }
  },
  async created () {
    this.allSearchLabelListOrigin = await this.getAllLabelLists()
    // this.handleSearchLabelAllList()
  },
  methods: {
    // 获取所有下拉列表
    async getAllLabelLists () {
      if (!this.$store.state.label.list.length) await this.$store.dispatch('label/getSearchLabels')
      return this.$store.state.label.list
    },
    getChooseContexts (speChoose) {
      let contextsMap = this.$store.state.bmap.labelContextMap
      let data = speChoose.map(el => {
        return contextsMap[el]
      })
      let sort = [...new Set(data.map(el => el.code))]
      return sort.map(el => {
        let choose = data.filter(ele => ele.code === el)
        return {
          codeName: choose[0].codeName,
          choose
        }
      })
    },
    handleSearchLabelAllList () {
      let all = this.allSearchLabelListOrigin
      let list = all.filter(el => el.type !== '7').reduce(
        (data, cur) => data.concat(cur.labelResponses.map(ele => ({ ...ele, type: cur.type }))), []
      )
      let special = all.filter(el => el.type === '7').map(el => {
        el.codeName = el.typeName
        return el
      })
      this.allSearchLabelList = list.concat(special)
      this.afterHandleSearchLabelAllList && typeof this.afterHandleSearchLabelAllList === 'function' && this.afterHandleSearchLabelAllList()
    }
  }
}
